'use client'

import { createContext, useCallback, useContext, useRef } from 'react'

type NotificationsRefetchContextType = {
  refetchNotifications: () => void
  registerRefetch: (fn: () => void) => void
}

const NotificationsRefetchContext = createContext<NotificationsRefetchContextType>({
  refetchNotifications: () => {},
  registerRefetch: () => {},
})

export function NotificationsRefetchProvider({ children }: { children: React.ReactNode }) {
  const refetchRef = useRef<() => void>(() => {})

  const registerRefetch = useCallback((fn: () => void) => {
    refetchRef.current = fn
  }, [])

  const refetchNotifications = useCallback(() => {
    refetchRef.current()
  }, [])

  return (
    <NotificationsRefetchContext.Provider value={{ refetchNotifications, registerRefetch }}>
      {children}
    </NotificationsRefetchContext.Provider>
  )
}

export const useNotificationsRefetch = () => useContext(NotificationsRefetchContext)
